module.exports = __webpack_public_path__ + "_/_/src/assets/firesafety/direction-right/legend.png";